import React from "react";
import { cn } from "@/lib/utils";
import { SETTINGS_TABS } from "@/lib/settings/constants";

const LABELS = {
  integrations: "Integrations",
  billing: "Billing & Plans",
  usage: "Usage",
  devices: "Devices",
  preferences: "Preferences",
};

export function SettingsTabs({ activeTab, onChange }) {
  return (
    <div
      className="flex flex-wrap gap-1 border-b border-edge-subtle"
      data-testid="settings-tabs"
    >
      {SETTINGS_TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          data-testid={`settings-tab-${tab}`}
          onClick={() => onChange(tab)}
          className={cn(
            "px-3 h-9 text-compact border-b-2 -mb-px transition-colors",
            activeTab === tab
              ? "border-emerald-600 text-emerald-600 font-semibold"
              : "border-transparent text-ink-muted hover:text-ink-primary"
          )}
        >
          {LABELS[tab]}
        </button>
      ))}
    </div>
  );
}
